import React, { useEffect } from 'react';
import {
  Box,
  Paper,
  Group,
  Text,
  ThemeIcon,
  CloseButton,
} from '@mantine/core';

const variantStyles = {
  success: {
    color: 'green',
    icon: '✓',
  },
  error: {
    color: 'red',
    icon: '✕',
  },
  info: {
    color: 'blue',
    icon: 'ℹ️',
  },
};

const NotificationPopup = ({ type = 'info', message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const styles = variantStyles[type];

  return (
    <Box
      style={{
        position: 'fixed',
        top: '1.5rem',
        right: '1.5rem',
        zIndex: 9999,
        width: 300,
      }}
    >
      <Paper
        withBorder
        radius="md"
        p="sm"
        shadow="sm"
        style={{
          borderLeft: `4px solid var(--mantine-color-${styles.color}-6)`,
        }}
      >
        <Group align="center" justify='space-between' spacing="sm" noWrap>
          <ThemeIcon
            color={styles.color}
            variant="light"
            radius="xl"
            size="sm"
            style={{ fontSize: 12, fontWeight: 'bold' }}
          >
            {styles.icon}
          </ThemeIcon>

          <Box style={{ flex: 1 }}>
            <Text size="sm" fw={500} c={`${styles.color}.8`}>
              {message}
            </Text>
          </Box>

          <CloseButton onClick={onClose} />
        </Group>
      </Paper>
    </Box>
  );
};

export default NotificationPopup;
